import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip, Modal } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../../common_functions/index';

const ConceptualWorkList = props => {
  const [conceptualWork, setConceptualWork] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{record.name}</span>,
      ...filter('name'),
    },
    {
      title: 'Portfolio Number',
      dataIndex: 'number',
      key: 'number',
      // sorter: true,
      ...filter('number'),
    },
    {
      title: 'Artist',
      dataIndex: 'artist.First_Name',
      key: 'artist.First_Name',
      sorter: true,
      render: (text, record) => (
        <span style={{ textTransform: 'capitalize' }}>{!!record.artist && `${record.artist.First_Name} ${record.artist.last_name}`}</span>
      ),
      ...filter('artist.First_Name'),
    },
    {
      title: 'Edition Size',
      dataIndex: 'edition_size',
      key: 'edition_size',
      sorter: true,
      ...filter('edition_size'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/portfolio-conceptual-works/edit/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_portfolio_conceptual_works?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_portfolio_conceptual_works?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'portfolio',
              'Portfolio conceptual work?',
              conceptualWork,
              setConceptualWork,
              props?.tabs_permissions?.settings_portfolio_conceptual_works?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getConceptualData(pagination);
  })();
  }, []);

  const getConceptualData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    filters['type'] = { _eq: process.env.conceptual_work_id };
    try {
      const response = await props.getItems('portfolio', {
        fields: ['*,artist.First_Name,artist.last_name'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setConceptualWork(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          if (key == 'artist.First_Name') {
            filtersitems['_or'] = [{ artist: { last_name: { _icontains: val[0] } } }, { artist: { First_Name: { _icontains: val[0] } } }];
          } else if (key === 'edition_size') {
            filtersitems[key] = { _eq: Number(val[0]) };
          } else {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
    }
    await getConceptualData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/portfolio-conceptual-works" }, { title: "Portfolio Conceptual Work" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Portfolio Conceptual Work
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions?.settings_portfolio_conceptual_works,
                `/settings/portfolio-conceptual-works/new`,
                'Create Portfolio Conceptual Work'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={conceptualWork}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ConceptualWorkList;
